import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <footer class="w-full text-white pt-12 pb-6 px-4 sm:px-6 md:px-12" style="background-color: var(--bg-main, #e11d48);">
      <div class="max-w-7xl mx-auto">
        
        <!-- GRID PRINCIPAL (5 COLUMNAS EN ESCRITORIO) -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          
          <!-- COLUMNA 1: BRANDING & CONTACTO -->
          <div class="flex flex-col gap-4">
            <!-- LOGO -->
            <div class="flex items-center gap-2">
              <svg class="w-8 h-8 text-white fill-current" viewBox="0 0 24 24">
                <!-- Icono de Rosa / Flor -->
                <path d="M12 2C9.24 2 7 4.24 7 7c0 2.1 1.3 3.89 3.13 4.61C7.8 12.38 6 14.97 6 18h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.03-1.8-5.62-4.13-6.39C17.7 10.89 19 9.1 19 7c0-2.76-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"/>
              </svg>
              <span class="text-2xl font-bold tracking-tight lowercase">undetalle</span>
            </div>

            <!-- DESCRIPCIÓN -->
            <p class="text-xs sm:text-sm text-white/90 leading-relaxed">
              Florería Undetalle | Envío de flores, plantas y regalos a domicilio en el mismo día | en Lima y Callao
            </p>

            <!-- HORARIOS Y CONSULTAS -->
            <div class="text-xs sm:text-sm space-y-2 mt-2">
              <p>
                <strong class="block font-bold">Horario de atención ventas:</strong>
                <span class="text-white/90">Lunes a sábados: 7 a. m a 10 p. m.</span>
              </p>
              <p>
                <strong class="block font-bold">Consultas:</strong>
                <a href="mailto:hola@undetalle.com.pe" class="text-white/90 hover:underline">
                  hola&#64;undetalle.com.pe
                </a>
              </p>
            </div>

            <!-- REDES SOCIALES -->
            <div class="flex items-center gap-3 mt-2">
              <a href="#" class="w-8 h-8 rounded-full border border-white/70 flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Facebook">
                <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H7.5v-3H10V9.69c0-2.47 1.47-3.83 3.72-3.83 1.08 0 2.2.19 2.2.19v2.42h-1.24c-1.23 0-1.61.76-1.61 1.54V12h2.72l-.43 3H13v6.8c4.56-.93 8-4.96 8-9.8z"/>
                </svg>
              </a>
              <a href="#" class="w-8 h-8 rounded-full border border-white/70 flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Twitter">
                <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
                </svg>
              </a>
              <a href="#" class="w-8 h-8 rounded-full border border-white/70 flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="YouTube">
                <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          <!-- COLUMNA 2: CONÓCENOS -->
          <div class="flex flex-col">
            <h3 class="font-bold text-base tracking-wider uppercase mb-4">CONÓCENOS</h3>
            <ul class="space-y-2 text-xs sm:text-sm text-white/90 uppercase">
              <li><a href="#" class="hover:underline">Quiénes somos</a></li>
              <li><a routerLink="/seguimiento" class="hover:underline">Rastrear pedido</a></li>
              <li><a href="#" class="hover:underline">Trabaja con nosotros</a></li>
              <li><a href="#" class="hover:underline">Preguntas frecuentes</a></li>
              <li><a href="#" class="hover:underline">Políticas de envío</a></li>
              <li><a href="#" class="hover:underline">Privacidad</a></li>
              <li><a href="#" class="hover:underline">Políticas de cookies</a></li>
              <li><a href="#" class="hover:underline">Términos y condiciones</a></li>
              <li><a href="#" class="hover:underline font-bold">Libro de reclamaciones</a></li>
            </ul>

            <!-- RUC Y BANNER LIBRO DE RECLAMACIONES -->
            <div class="mt-4 space-y-2">
              <div class="flex items-center gap-1.5 text-xs">
                <svg class="w-4 h-4 text-white flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                </svg>
                <span class="font-semibold uppercase text-[11px]">UNDETALLE E.I.R.L RUC: 20607698865</span>
              </div>
              <div class="bg-white rounded p-2 inline-block max-w-[160px]">
                <div class="text-center text-sky-700 text-xs font-bold leading-tight">
                  Libro de<br>Reclamaciones
                </div>
                <!-- Icono de libro ilustrativo -->
                <svg class="w-10 h-10 mx-auto text-sky-600 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
            </div>
          </div>

          <!-- COLUMNA 3: TIPOS DE FLORES -->
          <div class="flex flex-col">
            <h3 class="font-bold text-base tracking-wider uppercase mb-4">TIPOS DE FLORES</h3>
            <ul class="space-y-2.5 text-xs sm:text-sm text-white/90 uppercase">
              <li><a href="#" class="hover:underline">Rosas</a></li>
              <li><a href="#" class="hover:underline">Girasoles</a></li>
              <li><a href="#" class="hover:underline">Tulipanes</a></li>
              <li><a href="#" class="hover:underline">Orquídeas</a></li>
              <li><a href="#" class="hover:underline">Gerberas</a></li>
              <li><a href="#" class="hover:underline">Astromelias</a></li>
              <li><a href="#" class="hover:underline">Claveles</a></li>
            </ul>
          </div>

          <!-- COLUMNA 4: OCASIONES -->
          <div class="flex flex-col">
            <h3 class="font-bold text-base tracking-wider uppercase mb-4">OCASIONES</h3>
            <ul class="space-y-2.5 text-xs sm:text-sm text-white/90 uppercase">
              <li><a href="#" class="hover:underline">San Valentín</a></li>
              <li><a href="#" class="hover:underline">Cumpleaños</a></li>
              <li><a href="#" class="hover:underline">Aniversario</a></li>
              <li><a href="#" class="hover:underline">Graduación</a></li>
              <li><a href="#" class="hover:underline">Nacimientos</a></li>
              <li><a href="#" class="hover:underline">Recupérate pronto</a></li>
              <li><a href="#" class="hover:underline">Para él</a></li>
            </ul>
          </div>

          <!-- COLUMNA 5: REGALOS Y APPS -->
          <div class="flex flex-col">
            <h3 class="font-bold text-base tracking-wider uppercase mb-4">REGALOS</h3>
            <ul class="space-y-2.5 text-xs sm:text-sm text-white/90 uppercase mb-6">
              <li><a href="#" class="hover:underline">Peluches</a></li>
              <li><a href="#" class="hover:underline">Globos</a></li>
              <li><a href="#" class="hover:underline">Personalizados</a></li>
            </ul>

            <!-- <h4 class="font-bold text-xs sm:text-sm tracking-wider uppercase mb-3">DESCARGA NUESTRA APP</h4>
            <div class="flex flex-col gap-2.5">
              <a href="#" class="inline-block hover:opacity-90 transition-opacity">
                <div class="bg-black text-white px-3 py-1.5 rounded-md flex items-center gap-2 border border-white/20 w-fit">
                  <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                    <path d="M3 20.5v-17c0-.55.45-1 1-1 .2 0 .39.06.56.17l14.5 8.5c.57.33.57 1.17 0 1.5L4.56 21.33c-.17.11-.36.17-.56.17-.55 0-1-.45-1-1z"/>
                  </svg>
                  <div class="text-left leading-none">
                    <span class="text-[9px] uppercase tracking-wider text-gray-300 block">Disponible en</span>
                    <span class="text-xs font-semibold tracking-wide">Google Play</span>
                  </div>
                </div>
              </a>

              <a href="#" class="inline-block hover:opacity-90 transition-opacity">
                <div class="bg-black text-white px-3 py-1.5 rounded-md flex items-center gap-2 border border-white/20 w-fit">
                  <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.32c.68-.82 1.14-1.97 1.01-3.12-.98.04-2.17.65-2.87 1.47-.63.73-1.18 1.9-1.03 3.03 1.1.08 2.21-.56 2.89-1.38z"/>
                  </svg>
                  <div class="text-left leading-none">
                    <span class="text-[9px] uppercase tracking-wider text-gray-300 block">Consíuelo en el</span>
                    <span class="text-xs font-semibold tracking-wide">App Store</span>
                  </div>
                </div>
              </a>
            </div> -->
          </div>

        </div>

        <!-- LINEA SEPARADORA Y COPYRIGHT -->
        <div class="border-t border-white/30 pt-6 text-center">
          <p class="text-xs sm:text-sm uppercase tracking-wide text-white/90">
            UNDETALLE ©COPYRIGHT 2026. BY HUMANO COMPUTADOR - TODOS LOS DERECHOS RESERVADOS.
          </p>
        </div>

      </div>
    </footer>
  `
})
export class FooterComponent { }